// --- Main URL validator

import { isLoopbackOrLinkLocalOrULA } from './isLoopbackOrLinkLocalOrULA';
import { ipv4Re, isPrivateIPv4 } from './isPrivateIPv4';

export function isSafeHttpUrl(input: string): boolean {
  // quick rejects
  if (!input || input.length > 2048 || /\s/.test(input)) return false;

  // Must be absolute URL with http/https only
  let url: URL;
  try {
    url = new URL(input);
  } catch {
    return false;
  }

  if (url.username || url.password) return false; // block userinfo
  if (!['http:', 'https:'].includes(url.protocol)) return false;

  const host = url.hostname;

  // Block private/loopback ranges (mitigate SSRF-style abuse)
  if (isPrivateIPv4(host) || isLoopbackOrLinkLocalOrULA(host)) return false;

  // Require a dot in hostname to avoid bare words (unless you *want* to allow internal hosts)
  if (!ipv4Re.test(host) && !host.includes('.')) return false;

  // Block suspicious TLD-less or malformed hosts
  if (!host || host.startsWith('-') || host.endsWith('-')) return false;

  // Block non-http(s) disguised via encoded scheme (defense-in-depth)
  if (/^(javascript|data|file|blob):/i.test(decodeURIComponent(input)))
    return false;

  return true;
}
